import type { Difficulty } from './types';

export const DIFFICULTIES: Difficulty[] = [
  {
    id: 'apprentice',
    name: '沐光學徒',
    gender: 'female',
    english: 'DAWN APPRENTICE',
    title: '入門・看見威脅',
    description: '會看見一手威脅，但會刻意留下可把握的空隙，適合熟悉活三、眠三與基本防守。',
    strength: 8,
    thinkTime: 260,
    accent: '#8ca999',
    image: '/characters/apprentice.webp',
    cardImage: '/characters/cards/apprentice-card.webp',
    rank: '第一階・入門',
    strengthLabel: 'Rapfi 8%・每手約 0.3 秒',
    playStyle: '溫和試探，偶爾放過雙向威脅。',
    styleType: 'growth',
    styleLabel: '成長型',
    attack: 42,
    defense: 38,
  },
  {
    id: 'keeper',
    name: '青竹棋士',
    gender: 'male',
    english: 'BAMBOO KEEPER',
    title: '穩健・攻守有序',
    description: '優先封住要點，再沿著好棋形施壓。適合已懂基本攻防、想練習判斷先後手的玩家。',
    strength: 28,
    thinkTime: 520,
    accent: '#5f9f7d',
    image: '/characters/keeper.webp',
    cardImage: '/characters/cards/keeper-card.webp',
    rank: '第二階・穩健',
    strengthLabel: 'Rapfi 28%・每手約 0.5 秒',
    playStyle: '防守優先，等待你的棋形出現斷點。',
    styleType: 'defense',
    styleLabel: '防守型',
    attack: 48,
    defense: 86,
  },
  {
    id: 'strategist',
    name: '赤紋策士',
    gender: 'female',
    english: 'CRIMSON TACTICIAN',
    title: '進階・連續進攻',
    description: '擅長製造活三、衝四與雙向威脅。若只處理眼前一手，很快會失去主動權。',
    strength: 62,
    thinkTime: 1050,
    accent: '#bd6a5c',
    image: '/characters/strategist.webp',
    cardImage: '/characters/cards/strategist-card.webp',
    rank: '第三階・進階',
    strengthLabel: 'Rapfi 62%・每手約 1.1 秒',
    playStyle: '主動搶先，連續製造必須回應的威脅。',
    styleType: 'attack',
    styleLabel: '進攻型',
    attack: 92,
    defense: 58,
  },
  {
    id: 'weaver',
    name: '玄霧棋師',
    gender: 'male',
    english: 'MIST WEAVER',
    title: '幻變・攻守易位',
    description: '不固定採取進攻或防守，會在評價相近的候選著間轉換方向，擅長交叉威脅、誘導與突然變奏。',
    strength: 82,
    thinkTime: 1700,
    accent: '#9584b8',
    image: '/characters/weaver.webp',
    cardImage: '/characters/cards/weaver-card.webp',
    rank: '第四階・幻變',
    strengthLabel: 'Rapfi 82%・每手約 1.7 秒',
    playStyle: '依棋勢切換攻守；你追逐表面威脅時，真正的落點可能已經轉向。',
    styleType: 'adaptive',
    styleLabel: '變幻型',
    attack: 82,
    defense: 74,
  },
  {
    id: 'guardian',
    name: '雲門守局人',
    gender: 'male',
    english: 'CLOUD GUARDIAN',
    title: '宗師・Rapfi 全力',
    description: '不再刻意收手，以完整棋力與較長思考守住終局。適合驗證開局研究與高強度攻防。',
    strength: 100,
    thinkTime: 2600,
    accent: '#d5b779',
    image: '/characters/guardian.webp',
    cardImage: '/characters/cards/guardian-card.webp',
    rank: '第五階・宗師',
    strengthLabel: 'Rapfi 100%・每手約 2.6 秒',
    playStyle: '完整搜尋，不主動讓棋；失誤通常會被立即懲罰。',
    styleType: 'balanced',
    styleLabel: '均衡型',
    attack: 96,
    defense: 96,
  },
];

export function difficultyById(id: string): Difficulty | undefined {
  return DIFFICULTIES.find((item) => item.id === id);
}
